// extracted by mini-css-extract-plugin
export var sidebarHidden = "Ni89i";
export var sidebarVisible = "a7Ps_";